import apiClient from "config/apiClient";
import { DEFAULT_LIMIT_ITEMS } from "constants/data";
import insertObjectIf, { toSnakeCase } from "util/helper";
import Notify from "config/notify";
import { VendorListRequest, MstVendorSelectResponse, MstVendorDetail } from "../types/vendor";

/**
 *  get vendor list
 * @param body VendorQuery
 */
export async function getVendorListApi(body?: VendorListRequest): Promise<MstVendorSelectResponse> {
  const res = await apiClient.post<MstVendorSelectResponse>(
    `/mst/vendor/select`,
    toSnakeCase({
      limit: body?.limit || DEFAULT_LIMIT_ITEMS,
      offset: body?.offset || 1,
      ...insertObjectIf(body?.status_flag, { status_flag: body?.status_flag }),
      ...insertObjectIf(body?.vendor_cd_or_name, { vendor_cd_or_name: body?.vendor_cd_or_name }),
      ...insertObjectIf(body?.send_pattern !== undefined, { send_pattern: body?.send_pattern }),
    }),
  );
  return { list: res.data?.list || [], total: res.data?.total || 0 };
}

/**
 * Updates the vendor information using the provided request body.
 *
 * @param {VendorListRequest} [body] - The request body containing vendor information to be updated.
 * @returns {Promise<MstVendorSelectResponse>} A promise that resolves to the response containing the updated vendor list and total count.
 *
 * @example
 * const requestBody = {
 *   vendor_cd: '123',
 *   status_flag: 2,
 *   vendor_cd_or_name: 'Vendor Name',
 *   send_pattern: 'Pattern'
 * };
 *
 * updateVendorApi(requestBody).then(response => {
 *   console.log(response.list);
 *   console.log(response.total);
 * });
 */
export async function updateVendorApi(body?: MstVendorDetail): Promise<any> {
  const res = await apiClient.post<MstVendorSelectResponse>(
    `/mst/vendor/update`,
    {
      vendor_cd: body?.yh_vendor_cd,
      status_flag: body?.mst_vendor_status_flag,
      mst_vendor: {
        vendor_name: body?.mst_vendor_vendor_name,
        email_address: body?.mst_vendor_email_address
          ?.split(',')
          .map(email => email.trim())
          .join(','),
        shipping_receipt_method: body?.mst_vendor_shipping_receipt_method,
        ...insertObjectIf(body?.mst_vendor_receiving_setting !== "" && body?.mst_vendor_receiving_setting !== undefined, {
          receiving_setting: body?.mst_vendor_receiving_setting,
        }),
        zaiko_kansi: 0,
        auth_cd_update_flg: body?.auth_cd_update_flg ? 1 : 0,
        shortage_period: body?.mst_vendor_shortage_period ? Number(body?.mst_vendor_shortage_period) : undefined,
      },
    },
  );
  if (res.status === 200) {
    Notify.setNotification({
      show: true,
      title: "更新が完了しました",
      confirmLabel: "OK",
      actionsPosition: "center",
    });
  }
  return res.data;
}
